<template>
  <div class="row">
    <div class="col-md-3">
      <b>Calificacion del proceso:</b>
      <select v-model="project_qualification" name="project_qualification" id="project_qualification" class="form-control">
        <option value="">Calificacion de proceso</option>
        <option value="1">Confiable</option>
        <option value="0">No confiable</option>
        <option value="2">Confiable con Observaciones</option>
      </select>
    </div>
    <div class="col-md-3">
      <b>Tipo de asignación:</b>
      <select v-model="assignment_type" name="assignment_type" id="assignment_type" class="form-control">
        <option value="">Todos los tipos de asignaciónes</option>
        <option value="3">Laboral</option>
        <option value="1">Académico</option>
        <option value="2">Antecedentes</option>
        <option value="11">Personal</option>
        <option value="4">Visita Domicialiaria</option>
        <option value="5">Visita Domicialiaria Basica</option>
        <option value="8">Verifiación Data Credito</option>
      </select>
    </div>
    <div class="col-md-3">
      <b>Calificacion del asignación:</b>
      <select v-model="assigment_qualification" name="assigment_qualification" id="assigment_qualification" class="form-control">
        <option value="">Todos los estados de asignación</option>
        <option value="1">1</option>
        <option value="2">2</option>
        <option value="3">3</option>
        <option value="4">4</option>
        <option value="5">5</option>
      </select>
    </div>
    <div class="col-md-3">
      <b>Fecha inicial:</b>
      <input type="date" v-model="create_at" name="start_date" class="form-control" value="">
    </div>
    
    <button type="button" @click="searchAssignments" id="searchButton" class="btn btn-success" data-dismiss="modal">Buscar</button>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name:'FilterAssignment',
  data(){
    return{
      assigment_qualification:0,
      assignment_type:null,
      project_qualification:null,
      create_at:null
    }
  },
  methods:{
    async searchAssignments(){
      let url = `/search_assignments?assigment_qualification=${this.assigment_qualification}&assignment_type=${this.assignment_type}`
      url +=`&project_qualification=${this.project_qualification}&created_at=${this.create_at}`
      window.open(url)
    }
  }
}
</script>

<style>

</style>